import React from "react";
import { connect } from "react-redux";
import { Div, RefreshIcon } from "components/Base";
import { getters, actions } from "Portal/CallForPapersForm/model";

const decorate = connect(
  state => ({
    isViewingDraftSubmission: getters.isViewingDraftSubmission(state),
    isViewingOtherUserDraftSubmission: getters.isViewingOtherUserDraftSubmission(
      state
    )
  }),
  {
    onDeleteDraft: actions.onDeleteDraft
  }
);

const ResetSavedData = ({
  onDeleteDraft,
  isViewingDraftSubmission,
  isViewingOtherUserDraftSubmission
}) =>
  !isViewingDraftSubmission || isViewingOtherUserDraftSubmission ? null : (
    <Div display="row.flex-end.center">
      <Div
        display="row.flex-start.center"
        fs={2}
        color="#494949"
        mb={2}
        onClick={() => onDeleteDraft()}
        underline={{ default: false, hover: true }}
      >
        <RefreshIcon size={16} color="#494949" mr={1} />
        Reset saved data
      </Div>
    </Div>
  );

export default decorate(ResetSavedData);
